import React from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import LinkButton from '../LinkButton';
import { useEntityData, useRefetch } from '../../../../EntityContext';
import { AddLinkModal } from '../../../../components/styled/AddLinkModal';
import { mapLinkToLinkType } from '../../../../utils';
import { useTranslation } from '../../../../../../../i18n/useTranslation';

interface Props {
    hideLinksButton?: boolean;
    readOnly?: boolean;
}

const TooltipWrapper = styled.span<{ isReadOnly?: boolean }>`
    display: inline-block;
    cursor: ${(props) => (props.isReadOnly ? 'not-allowed' : 'pointer')};
`;

export default function LinksSection({ hideLinksButton, readOnly }: Props) {
    const { entityData } = useEntityData();
    const refetch = useRefetch();
    const { t } = useTranslation();
    const links = entityData?.institutionalMemory?.elements || [];

    const existingLinks = mapLinkToLinkType(links);

    return (
        <>
            {links.map((link) => (
                <div className="mb-2">
                    <LinkButton link={link} />
                </div>
            ))}
            {!hideLinksButton && (
                <Tooltip title={readOnly ? t('ASSET_MARKED_AS_READ_ONLY') : undefined}>
                    <TooltipWrapper isReadOnly={readOnly}>
                        <AddLinkModal
                            buttonProps={{ type: 'default', disabled: readOnly }}
                            refetch={refetch}
                            existingLinks={existingLinks}
                        />
                    </TooltipWrapper>
                </Tooltip>
            )}
        </>
    );
}
